export const formatModelName = (model: {
  name: string;
  folderPath?: { id: string; name: string }[] | null;
}) => {
  if (!model.folderPath || model.folderPath.length === 0) {
    return model.name;
  }
  return `${model.folderPath.map((x) => x.name).join(".")}.${model.name}`;
};
